import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ConsumerType } from "../types/types";
import { CONSUMER_STORE } from "../constants/constant";
import { getConsumerInsurancePrices } from "services/api/questions";

const initialConsumerState = {
  consumerCoveragePrices: undefined,
  consumerCoverageError: false,
  consumerCoverageErrorCode: undefined,
};

export const useConsumerStore = create(
  devtools(
    persist<ConsumerType>(
      (set) => ({
        ...initialConsumerState,
        setConsumerCoveragePrices: async (productId: string) => {
          try {
            set(() => ({
              consumerCoverageError: false,
              consumerCoverageErrorCode: undefined,
            }));
            const { coverages, extra_coverages, allianz_liability } =
              await getConsumerInsurancePrices(productId);
            set(() => ({
              consumerCoveragePrices: {
                ...(coverages?.options &&
                  Object.fromEntries(
                    Object.entries(coverages.options).map(
                      ([key, value]: [string, any]) => [key, value.price]
                    )
                  )),
                ...(extra_coverages &&
                  Object.fromEntries(
                    Object.entries(extra_coverages).map(
                      ([_, value]: [string, any]) => [value.id, value.price]
                    )
                  )),
                ...(allianz_liability && {
                  allianz_liability: allianz_liability.price,
                }),
              },
            }));
          } catch (err: any) {
            if (err.failed) {
              set(() => ({
                consumerCoverageError: true,
                consumerCoverageErrorCode: err.code,
              }));
            }
            console.error(err);
            throw err;
          }
        },
        clearConsumer: () => {
          set(() => initialConsumerState);
        },
      }),
      {
        name: CONSUMER_STORE,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
